import { MouseEventHandler, PropsWithChildren, Ref, forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import { NavLink as RouterLink } from 'react-router-dom';

const baseStyles = (theme: any) => ({
    fontFamily: 'TT Commons Pro Condensed',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    letterSpacing: '0.02em',
    textDecoration: 'none',
    padding: 0,
    border: 0,
    color: theme.palette.semantic.text.headerTabs,
    marginTop: '2px',
    backgroundColor: 'transparent',
    textTransform: 'uppercase' as React.CSSProperties['textTransform'],
    cursor: 'pointer',
    '&:hover': {
        color: theme.palette.semantic.text.inverse
    }
});

const Button = styled('button')(({ theme }) => ({
    ...baseStyles(theme)
}));

const ButtonLink = styled(RouterLink)(({ theme }) => ({
    ...baseStyles(theme),
    '&.active': {
        borderBottom: `2px solid ${theme.palette.semantic.bd.inverse}`,
        color: theme.palette.semantic.text.inverse
    }
}));

type Props = {
    onClick?: MouseEventHandler<HTMLButtonElement>;
    to?: string;
    style?: React.CSSProperties;
    id?: string;
    'aria-expanded'?: boolean;
    'aria-haspopup'?: React.AriaAttributes['aria-haspopup'];
};

const NavLink = forwardRef<HTMLAnchorElement | HTMLButtonElement, PropsWithChildren<Props>>(
    ({ onClick, children, to, ...restProps }, ref) => {
        if (to?.length) {
            return (
                <ButtonLink
                    ref={ref as Ref<HTMLAnchorElement>}
                    to={to}
                    className={({ isActive }) => (isActive ? 'active' : undefined)}
                    {...restProps}
                >
                    {children}
                </ButtonLink>
            );
        }

        return (
            <Button onClick={onClick} ref={ref as Ref<HTMLButtonElement>} {...restProps}>
                {children}
            </Button>
        );
    }
);

NavLink.displayName = 'NavLink';

export { NavLink };
